<script>
import { mapGetters } from 'vuex'
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'

import Resizable from '@src/mixins/resizable.js'
import Translatable from '@src/mixins/translatable.js'

import MobileViewCalculator from '@components/common/sliders/card-calculator-small.vue'
import Calculator from '@components/common/sliders/card-calculator.vue'
import Spinner from '@components/spinner.vue'

export default {
  components: {
    Calculator,
    MobileViewCalculator,
    SwiperSlide,
    Spinner,
    Swiper,
  },
  mixins: [Resizable, Translatable],
  props: {
    isEshop: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isBegin: true,
      isEnd: false,
      options: {
        allowTouchMove: true,
        spaceBetween: 8,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        pagination: {
          el: '.pagination',
          clickable: true,
          bulletClass: 'bullet',
          bulletActiveClass: 'bullet-active',
        },
        breakpoints: {
          320: {
            slidesPerView: 1.05,
            slidesPerGroup: 1.05,
          },
        },
      },
      optionsDesktop: {
        allowTouchMove: true,
        spaceBetween: 2,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        pagination: {
          el: '.pagination',
          clickable: false,
          bulletClass: 'bullet',
          bulletActiveClass: 'bullet-active',
        },

        slidesPerView: 3.03,
        slidesPerGroup: 3,
      },
    }
  },
  computed: {
    ...mapGetters('eShop', ['cards', 'cardsLoader']),
    swiper() {
      return this.$refs.calcSwiper ? this.$refs.calcSwiper.$swiper : ''
    },
    possibilitiesText() {
      return this.isBegin ? 'CALCULATOR_more_possibilities' : 'CALCULATOR_back'
    },
  },
  mounted() {
    if (this.swiper) {
      this.swiper.on('reachBeginning', () => {
        this.isBegin = true
        this.isEnd = false
      })
      this.swiper.on('reachEnd', () => {
        this.isBegin = false
        this.isEnd = true
      })
    }
  },
}
</script>

<template>
  <div>
    <div v-if="cardsLoader" class="loader-container">
      <Spinner />
    </div>
    <div v-else-if="cards.length" class="wrapper">
      <div v-if="desktopScreen" class="content">
        <div class="swiper-button-prev arrow">
          <span class="possibilities-arrow back"> </span>
        </div>
        <Swiper ref="calcSwiper" :options="optionsDesktop">
          <SwiperSlide v-for="(card, index) in cards" :key="index">
            <Calculator :key="index" :card="card" :is-eshop="isEshop" />
          </SwiperSlide>
          <div slot="pagination" class="pagination"></div>
        </Swiper>

        <div class="swiper-button-next arrow">
          <span class="possibilities-arrow"> </span>
        </div>
      </div>
      <Swiper v-else ref="calcSwiper" :options="options">
        <SwiperSlide v-for="(card, index) in cards" :key="index">
          <MobileViewCalculator :card="card" :is-eshop="isEshop" />
        </SwiperSlide>
        <div slot="pagination" class="pagination"></div>
      </Swiper>
    </div>
    <div v-else class="wrapper">
      <div class="text">{{
        getTranslatedContent('CALCULATOR_service_error')
      }}</div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import '@design';

.content {
  margin-top: 15px;
  display: flex;
  align-items: center;
}

.back {
  margin-right: 5px;
}

.arrow {
  width: 1px !important;
  margin: 10px;
}

.show-possibilities-wrapper {
  display: none;
}

.text {
  font-family: Open Sans Bold, sans-serif;
  font-weight: bold;
  font-size: 14px;
  line-height: 23px;
  color: $black;
  margin: 30px 0 0 0;
}

.loader-container {
  height: 320px;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.pagination {
  margin-top: 15px;
}

.pagination-wrapper {
  display: flex;
  width: 100%;
  flex-direction: row;
}
.wrapper {
  width: 100%;
}

.show-possibilities-wrapper {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  margin-top: -13px;
}

.more-possibilities {
  width: 78px;
  margin-left: auto;

  font-family: Open Sans, sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 16px;
  text-align: right;
  text-transform: uppercase;
  color: $dark-blue;
}

.possibilities-arrow {
  // arrow fix
  background: url('../../assets/icons/right-arrow-orange.svg') center no-repeat;
  width: 24px;
  height: 24px;
  margin-left: 5px;
  padding-right: 20px;
  cursor: pointer;

  &.back {
    transform: scaleX(-1);
  }
}

.swiper-button-next,
.swiper-button-prev {
  width: 30%;
  position: initial;
  margin-top: 0;

  &::after {
    content: none;
  }
}

.text {
  margin: 20px 0 20px 0;
}

.loader-container {
  height: 380px;
}
</style>
